<div [class]="isMobile ? '' : 'booble-backdrop'">
  <div [class]="isMobile ? '' : 'xp-modal xp-modal-cadastro'">
    <div
      [class]="
        isMobile
          ? ''
          : 'modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm'
      "
    >
      <div [class]="isMobile ? '' : 'modal-content'">
        <div [class]="isMobile ? '' : 'modal-dialog-scrollable-general'">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">Conta para recebimento</div>
                <p class="p-text-grey font-weight-400 mg-top-8">
                  Informe uma conta bancária para recebimento dos reais no
                  Brasil.
                </p>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div class="modal-body">
            <div [class]="isMobile ? '' : 'container-modal'" class="mg-top-24">
              <div class="d-flex justify-content-between">
                <span class="title-form"> Conta bancária </span>
                <span class="text-required-form"> * Campos obrigatórios </span>
              </div>

              <div *ngIf="companyId" class="row mg-top-32">
                <div class="col">
                  <div class="col-info">
                    <div class="d-flex justify-content-between margin-mb-16">
                      <div class="d-flex gap-10">
                        <img src="assets/image/information-icon.svg" />

                        <p class="text-p">
                          <strong class="weight-500"
                            >Apenas conta bancária de pessoa jurídica</strong
                          >
                        </p>
                      </div>
                    </div>

                    <p class="text-p text-information">
                      Lembramos que a conta bancária para recebimento deve ser
                      exclusivamente jurídica e com mesma titularidade do CNPJ
                      cadastrado.
                    </p>
                  </div>
                </div>
              </div>

              <div *ngIf="!companyId" class="row mg-top-32">
                <div class="col">
                  <div class="col-info">
                    <div class="d-flex justify-content-between margin-mb-16">
                      <div class="d-flex gap-10">
                        <img src="assets/image/information-icon.svg" />

                        <p class="text-p">
                          <strong class="weight-500"
                            >Apenas conta bancária de propriedade do
                            titular</strong
                          >
                        </p>
                      </div>
                    </div>

                    <p class="text-p text-information">
                      Lembramos que a conta bancária para recebimento deve ser
                      exclusivamente uma conta bancária de propriedade do CPF
                      cadastrado.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <form [formGroup]="accountForm">
                  <div class="row">
                    <div class="col-md-8">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Banco</mat-label>
                        <mat-select
                          (selectionChange)="changeBank($event)"
                          formControlName="name"
                          required
                          #singleSelect
                        >
                          <mat-option>
                            <ngx-mat-select-search
                              placeholderLabel="Banco"
                              noEntriesFoundLabel="Nenhum resultado encontrado"
                              [formControl]="bankFilterCtrl"
                            ></ngx-mat-select-search>
                          </mat-option>
                          <mat-option
                            *ngFor="let bank of filteredBanks | async"
                            [value]="bank.name"
                          >
                            {{ bank.code }} - {{ bank.name }}
                          </mat-option>
                        </mat-select>
                        <mat-error
                          *ngIf="
                            accountFormControl.name.touched &&
                            accountFormControl.name.errors?.required
                          "
                        >
                          Banco obrigatório</mat-error
                        >
                      </mat-form-field>
                    </div>
                    <div class="col-md-2">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Agência</mat-label>
                        <input
                          matInput
                          formControlName="agency"
                          type="text"
                          class=""
                          name="agency"
                          required
                        />
                        <mat-error
                          *ngIf="
                            accountFormControl.agency.touched &&
                            accountFormControl.agency.errors?.required
                          "
                        >
                          Agência obrigatória</mat-error
                        >
                      </mat-form-field>
                    </div>
                    <div class="col-md-2">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Conta com dígito</mat-label>
                        <input
                          matInput
                          formControlName="number"
                          type="text"
                          class=""
                          name="number"
                          required
                        />
                        <mat-error
                          *ngIf="
                            accountFormControl.number.touched &&
                            accountFormControl.number.errors?.required
                          "
                        >
                          Conta com dígito obrigatória</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="modal-footer-new">
            <button
              [disabled]="accountForm.invalid || loading"
              (click)="sendAccountInbound()"
              type="button"
              class="btn-footer btn btn-block"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              type="button"
            >
              Enviar conta bancária
              <span
                class="spinner-border spinner-border-sm"
                *ngIf="loading"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
